import React from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import analytics from "services/analytics";

export const Footer = ({
  footerShow = true,
  footerRegistration,
  footerShowLogo,
  footerLogo,
  footerShowText,
  footerText,
  footerPrivacyPolicy,
}) => {
  // const onClickHandler = () => {
  //   analytics.fireEvent({
  //     category: "External Link",
  //     action: "Privacy Policy",
  //     label: window.location.host,
  //   });
  // };

  return (
    footerShow && (
      <FooterWrapper as="footer" footerRegistration={footerRegistration}>
        <FooterContainer footerRegistration={footerRegistration}>
          {footerShowText && (
            <FooterText footerRegistration={footerRegistration}>
              {ReactHtmlParser(footerText)}
              {ReactHtmlParser(footerPrivacyPolicy)}
            </FooterText>
          )}

          {footerShowLogo && (
            <FooterLink
              href="https://musicaford.com/"
              target="_blank"
              rel="noopener noreferrer"
              footerRegistration={footerRegistration}
              onClick={() => {
                analytics.fireEvent({
                  category: "External Link",
                  action: "Hub Page",
                  label: window.location.href,
                });
              }}
            >
              <FooterLogo src={footerLogo} />
            </FooterLink>
          )}
        </FooterContainer>
      </FooterWrapper>
    )
  );
};

const FooterWrapper = styled.footer`
  background: ${(props) => (props.footerRegistration ? "#102b4e" : "#ffffff")};
  color: ${(props) => (props.footerRegistration ? "#ffffff" : "#000000")};
  font-size: 10px;

  a,
  a:visited {
    color: ${(props) => (props.footerRegistration ? "#ffffff" : "#000000")};
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 15px;
  width: 100%;
  flex-direction: ${(props) =>
    props.footerRegistration ? "column" : "column-reverse"};
  align-items: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: ${(props) =>
      props.footerRegistration ? "row" : "column-reverse"};
    padding: 60px 40px;
  }
`;

const FooterText = styled.div`
  text-align: ${(props) => (props.footerRegistration ? "left" : "center")};
  max-width: ${(props) => (props.footerRegistration ? "auto" : "600px")};
`;

const FooterLogo = styled.img`
  width: 100%;
`;

const FooterLink = styled.a`
  width: 100%;
  max-width: ${(props) => (props.footerRegistration ? "290px" : "150px")};
  margin: 0 auto;
  margin-bottom: ${(props) => !props.footerRegistration && "15px"};
  margin-top: ${(props) => props.footerRegistration && "25px"};

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    margin-top: 0;
    margin-left: ${(props) => props.footerRegistration && "55px"};
  }
`;
